/*
export function someGetter (state) {
}
*/
export function getToken(state) {
  return state.token
}
export function getAvatar(state) {
  return state.avatar
}
export function getProfileId(state) {
  return state.profileId
}
export function getUsername(state) {
  return state.username
}
export function getRolename(state) {
  //we need to transform 'Provider admin' to 'ProviderAdmin'
  return state.rolename
    ? state.rolename
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.substring(1))
        .join('')
    : null
}
export function getMainFolderId(state) {
  return parseInt(state.mainFolderId)
}
export function getUser(state) {
  return state.user
}
export function getSettings(state) {
  return state.user.settings ? JSON.parse(state.user.settings) : false
}
